'use client';

import React from 'react';

import { RichText } from '@/components/RichText';
import { Media } from '@/components/Media';
import { cn } from '@/utilities/cn';
import { FeaturesBlock } from '@payload-types';

export const FeatureCard: React.FC<{
  data: FeaturesBlock['features'][number];
  featuresBackgroundColor?: string | null;
  numberAsIcon?: boolean | null;
  index: number;
  className?: string;
}> = ({ data, numberAsIcon, featuresBackgroundColor, index, className }) => {
  const { icon, title, content } = data;

  return (
    <div
      className={cn(
        'corners-md flex w-full flex-col border border-gray-500 p-4 pb-[42px] sm:px-2 sm:pt-3 sm:pb-5',
        featuresBackgroundColor && 'border-none',
        className,
      )}
      style={{ backgroundColor: featuresBackgroundColor || undefined }}
      data-name="Content"
    >
      {icon && <Media className="mb-[21px] md:mb-5" resource={icon} />}

      {numberAsIcon && (
        <div className="flex-center bg-blue mb-[13px] aspect-square w-10 rounded-full text-white md:w-8">
          {index + 1}
        </div>
      )}

      {title && <h4 className="h6">{title}</h4>}
      {content && <RichText className="mt-[9px] md:mt-2" data={content} />}
    </div>
  );
};
